<script lang="ts" setup>
/**
 * Password managers only offer to save a credential they can attach to an account, so a form
 * that asks for a password without ever asking for the email gives them nothing to file it
 * under. This hands them the username the password belongs to, out of the tab order and out of
 * the accessibility tree.
 */
interface Props {
  email: string;
}

defineProps<Props>();
</script>

<template>
  <input
    :value="email"
    type="text"
    name="username"
    autocomplete="username"
    readonly
    tabindex="-1"
    aria-hidden="true"
    class="sr-only"
  >
</template>
